import ajax from "../assets/uilt/ajax";

let monitoring = {
  /**getById */
  getById: (req) => {
    return ajax.get({
      url: "/back/monitoring/get-by-id",
      param: req.param,
      success: req.success,
    });
  },
  /**getPage */
  getPage: (req) => {
    return ajax.get({
      url: "/back/monitoring/get-page",
      param: req.param,
      success: req.success,
    });
  },

  /**disposeAlertTransaction */
  //disposeAlertTransaction: req => { return ajax.post({ url: "/back/alert-transaction/dispose-alertTransaction", param: req.param, success: req.success }) },

  /**渠道机构、平台查询酬金统计Excel导出 */
  //alertTransactionDetailedExport: "/back/alert-transaction/transaction-detailed-export",
};

export default monitoring;
